export default function setPredefinedFields(values) {
	return (dispatch) => {
		dispatch({
			type: 'SET_PREDEFINED_FIELDS',
			payload: values,
		});
	};
}